<template>
    <!-- <div slot="body" class="container offset-bottom"> -->
	<!-- <div class="weijiekongdan"> -->
        <!-- <div style="height:100%;padding-top:44px;"> -->
            <iframe :src="flowSrc" style="height:100%; width:100%;margin:0;border:0;"> </iframe>
        <!-- </div> -->
    <!-- </div> -->
</template>
 
 
<script>
export default {
 
 
    data() {
        return {
            flowSrc: null,
  }
    },
  created() {
        this.flowSrc = 'https://www.wjx.cn/vm/YaBB5ZY.aspx?width=750&source=iframe&s=t';  //直接给flowSrc赋值链接
    },
 
 
}
</script>
<style scoped>
	.weijiekongdan {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		/* padding: 20px; */
		/* padding-left: 10px; */
		background-color: #F0F0F0;
	}

</style>

